import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useMutation, useQuery } from "react-query";
import { PageHeaderSection } from "../../components/common/PageHeadSection";
import { Skeleton, Spin, TablePaginationConfig } from "antd";
import _ from "lodash";
import { StopFreeSaleService } from "../../services/StopFreeSaleService";
import { setPdfExportObject, toUnLoading } from "../../store/SiteSlice";
import { mdlStopFreeSaleListRequest } from "../../models/service-models/stop-free-sale/StopFreeSaleListRequest";
import { StopFreeSaleTable } from "../../components/stop-free-sale/StopFreeSaleTable";
import { HeaderButton } from "../../models/ui-models/HeaderButton";
import { enmPdfExportType } from "../../models/enums/PdfExportType";
import { mdlStopFreeSaleExport } from "../../models/domain/StopFreeSaleExport";
import { mdlPDFRendererProps } from "../../models/ui-models/PDFRendererProps";
import { enmPdfRendererType } from "../../models/enums/PdfRenderer";
import { SFModal } from "../../components/elements/SFModal";
import { StopFreeSaleExportEmail } from "../../components/stop-free-sale/StopFreeSaleExportEmail";
import { useNavigate } from "react-router-dom";
import { ExpandableStopFreeSaleSendedList } from "../../components/stop-free-sale/ExpandableStopFreeSaleSendedList";
import { AgencyEmailTemplate } from "../../components/stop-free-sale/AgencyEmailTemplate";
import { mdlStopFreeSaleMessage } from "../../models/domain/StopFreeSaleMessage";
import { mdlStopFreeSaleDetail } from "../../models/domain/StopFreeSaleDetail";
import { mdlStopFreeSaleCancelRequest } from "../../models/service-models/stop-free-sale/StopFreeSaleCancelRequest";
import { toast } from "react-toastify";
import { ObjectHelper } from "../../utils/ObjectHelper";
import { mdlStopFreeSale } from "../../models/domain/StopFreeSale";
import { mdlStopFreeSaleMailServiceRequest } from "../../models/service-models/stop-free-sale/StopFreeSaleMailServiceRequest";
import { useAppDispatch, useAppSelector } from "../../store/Hooks";
import { enmStopFreeSale } from "../../models/enums/StopFreeSale";


export const StopFreeSaleSended = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const [request, setRequest] = useState<mdlStopFreeSaleListRequest>({pageNumber:1, pageSize:10});
    const [selectedRowKeys, setSelectedRowKeys] = useState<number[]>();
    const [openEmailModal, setOpenEmailModal] = useState<boolean>(false);
    const [exportData, setExportData] = useState<mdlStopFreeSaleExport>();
    const [openAgencyEmailModal, setOpenAgencyEmailModal] = useState<boolean>(false);
    const [detailData, setDetailData] = useState<mdlStopFreeSaleDetail[]>();
    const [message, setMessage] = useState<mdlStopFreeSaleMessage>();
    const siteStore = useAppSelector((state) => state.site);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        if (!dataList){
            refetchList();
        }
    }, []);


    //#region API CALLS

    const {
        data: dataList,
        isLoading : isLoadingList,
        refetch:refetchList
    } = useQuery(
        ["getList", request],
        () => {
            return StopFreeSaleService.GetList({...request, IsSend:true, displayLength:_pagination.defaultPageSize, displayStart:_pagination.current });
        },
        {
            refetchOnWindowFocus: false,
            enabled: !!request,
        }
    );
    
    const _pagination =  {
            align: "center",
            current: dataList?.body?.pageNumber,
            pageSizeOptions: [10, 20, 50],
            defaultPageSize: 10,
            pageSize: dataList?.body?.resultCount,
            defaultCurrent: 1,
            responsive: true,
            showSizeChanger: true,
            total: dataList?.body?.totalCount,
            showTotal: (total: number, range: [number, number]) => t("pagination.total") + ` ${dataList?.body?.totalCount} ` + t("pagination.result"),
            locale: { items_per_page: "/ " + t("pagination.itemPerPage") }
    } as TablePaginationConfig;
    

    const getMailService = useMutation({
        mutationFn: (id:string) => {
          return StopFreeSaleService.GetMailService({stopFreeId: id} as mdlStopFreeSaleMailServiceRequest)
        },
      })

    const mailMutateOperations = (id:string, fnModal:Function) => {
        setExportData(undefined);
        setMessage(undefined);
        setDetailData(undefined);
        setIsLoading(true);
        getMailService.mutate(id, {
          onSuccess(data){
              if(data && data.body && data.header.success){
                    setExportData(({..._.first(data.body.mailData),["id"]:id}) as mdlStopFreeSaleExport);
                    setMessage(data.body.messages);
                    setDetailData(data.body.details?.map( x=> ({...x,["id"]:id})))
                    setIsLoading(false);
                    fnModal && fnModal();
              }
          }
        })
    }

    const handleAgencyMailPreview = (e:any) => {
        if(e.id == exportData?.id){
            setOpenAgencyEmailModal(true);
            return;
        }
        mailMutateOperations(e.id,(data:any) => { setOpenAgencyEmailModal(true)});
    }
    const handleEmailClick = (id:string) => {
        if(id == exportData?.id){
            setOpenEmailModal(true);
            return;
        }
        mailMutateOperations(id,(data:any) => { setOpenEmailModal(true)});
    }
    
    const { mutateAsync: cancel, isLoading: createLoading, data: createData } = useMutation(
        (request: mdlStopFreeSaleCancelRequest) => StopFreeSaleService.CancelOrNew(request),
        {
            onMutate(variables) {
            },
            onError: error => {
                console.log(error);
            },
            onSuccess(data:any, variables, context) {
                if (data.header && data.header.success) {
                    toast.success(t("common.success"));
                    refetchList();
                }
                else {
                    toast.error(ObjectHelper.getErrorMessage(data.header.messages));
                }
            },
        }
    );

    const handleCancelOrNewClick = (e:mdlStopFreeSale) => {
        cancel({id: e.id, cancelStatus: e.status })
    }

    const handlePrintClick = (id:string) => {
        if(id == exportData?.id){
            var exportProps: mdlPDFRendererProps = {
                params: { dataSource: exportData, message:message, detail:detailData },
                rendererType: enmPdfRendererType.StopFreeSaleTemplate,
                type: enmPdfExportType.PRINT
            }
            dispatch(setPdfExportObject(exportProps));
            return;
        }
        mailMutateOperations(id,(data:any) => { 
            var exportProps: mdlPDFRendererProps = {
                params: { dataSource: data.body.data, message:message, detail:detailData },
                rendererType: enmPdfRendererType.StopFreeSaleTemplate,
                type: enmPdfExportType.PRINT
            }
            dispatch(setPdfExportObject(exportProps));
        });
    }

    const handlePdfClick = (id:string) => {
        if(id == exportData?.id){
            var exportProps: mdlPDFRendererProps = {
                params: { dataSource: exportData, message:message, detail:detailData },
                rendererType: enmPdfRendererType.StopFreeSaleTemplate,
                type: enmPdfExportType.PDF
            }
            dispatch(setPdfExportObject(exportProps));
            return;
        }
        mailMutateOperations(id,(data:any) => { 
            var exportProps: mdlPDFRendererProps = {
                params: { dataSource: data.body.data, message:message, detail:detailData },
                rendererType: enmPdfRendererType.StopFreeSaleTemplate,
                type: enmPdfExportType.PDF
            }
            dispatch(setPdfExportObject(exportProps));
        });
    }
    
    const handleTableParamsChange = (filters: any) => {}
    const onRowSelect = (filters: any) => {}

    const handleExpandRowRenderer = (id: string) => {
        return <ExpandableStopFreeSaleSendedList id={id} />
    }

    const handlePaginationChange = (page: number, pageSize: number) => {
        const _request = { ...request, pageSize: pageSize ?? 10, pageNumber: page ?? 1 };
        setRequest(_request)
    }
    const getButtons = ():HeaderButton[] | undefined => {
        let _buttons:HeaderButton[] = [];
        return _buttons;
    }
    
    return (
        <>
            <SFModal
                width={window.innerWidth > 768 ?  (window.innerWidth * 50 / 100) : window.innerWidth}
                open={openEmailModal}
                toggler={() => { setOpenEmailModal(!openEmailModal) }}
                body={<StopFreeSaleExportEmail closePopup={() => { setOpenEmailModal(false) }}  fnAgencyMailPreview={handleAgencyMailPreview} dataSource={exportData} message={message} detail={detailData}/>}
                title={t("stopFreeSale.emailTitle")}
            />
            <SFModal
                width={window.innerWidth > 768 ?  (window.innerWidth * 50 / 100) : window.innerWidth}
                open={openAgencyEmailModal}
                toggler={() => { setOpenAgencyEmailModal(!openAgencyEmailModal) }}
                body={<AgencyEmailTemplate stopFreeSaleType={_.first(detailData)?.type ? enmStopFreeSale.FreeSale : enmStopFreeSale.StopSale} activeUser={siteStore.user} dataSource={exportData} detail={detailData} message={message} />}
                title={_.first(detailData)?.type ? t("stopSaleMailTemplate.emailTitleFree") : t("stopSaleMailTemplate.emailTitleStop")}
            />
            <div className="nk-content ">
                <div className="container-fluid">
                    <div className="nk-content-inner">
                        <div className="nk-content-body">
                            <PageHeaderSection
                                pageTitle={t("stopFreeSale.title")}
                                buttons={getButtons()}
                            />
                            <div className="nk-block">
                                <div className="card card-bordered h-100">
                                    <div className="card-inner">

                                    {
                                                    isLoadingList
                                                    &&
                                                    <>
                                                        <Skeleton active />
                                                        <Skeleton active />
                                                        <Skeleton active />
                                                    </>
                                                }
                                                {
                                                    dataList
                                                    &&
                                                    <Spin spinning={isLoading} tip="Loading...">
                                                        <StopFreeSaleTable
                                                            onCancelOrNew={handleCancelOrNewClick}
                                                            onEmailClick={handleEmailClick}
                                                            onPrintClick={handlePrintClick}
                                                            onPDFClick={handlePdfClick}
                                                            onRowSelection={onRowSelect}
                                                            selectedRowKeys={selectedRowKeys}
                                                            expandRowRenderer={handleExpandRowRenderer}
                                                            onPaginationChange={handlePaginationChange}
                                                            pagination={_pagination}
                                                            onTableParamsChange={handleTableParamsChange}
                                                            dataSource={dataList?.body?.data}
                                                        />
                                                    </Spin>
                                                }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>


    );
};